import { useEffect, useState } from 'react';
import { SAVED_FILTER_RESOURCE } from '../../../../../constants';

const useSavedFilterTimelineSources = (
  filter?: SavedFilter | DefaultDatasetFilter,
) => {
  const [sources, setSources] = useState<Timeline.EventSource[]>([]);
  useEffect(() => {
    if (!filter) {
      setSources([]);
      return;
    }

    setSources([
      {
        type: SAVED_FILTER_RESOURCE,
        id: filter.id,
      },
    ]);
  }, [filter]);

  return sources;
};

export default useSavedFilterTimelineSources;
